function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import PropTypes from "prop-types";
import React, { Component } from "react";
import classnames from "classnames";
import { icons } from "@brandwatch/axiom-materials";
import Base from "../Base/Base";
import { v4 as uuid } from "uuid";
import "./Icon.css";
export default class Icon extends Component {
  constructor(props) {
    super(props);
    this.titleId = "icon-title__" + uuid();
  }

  render() {
    const {
      color,
      className,
      inline,
      isImg = true,
      name,
      size,
      width,
      height,
      spaceLeft,
      spaceRight,
      style = {},
      title,
      ...rest
    } = this.props;
    const sizeStyle = height || width ? {
      width,
      height
    } : {
      width: size,
      height: size
    };
    const classes = classnames(className, "ax-icon", `ax-icon--${name}`, {
      "ax-icon--inline": inline,
      [`ax-icon--space-left-${spaceLeft}`]: spaceLeft,
      [`ax-icon--space-right-${spaceRight}`]: spaceRight
    });

    if (!icons[name]) {
      return null;
    }

    const {
      body,
      viewBox
    } = icons[name];
    let ariaObject = {};
    let bodyFinal = body;

    if (isImg) {
      ariaObject.role = "img";
    } else {
      ariaObject["aria-hidden"] = "true";
    }

    if (title) {
      bodyFinal = `<title id=${this.titleId}>${title}</title>${body}`;
      ariaObject["aria-labelledby"] = this.titleId;
    }

    return /*#__PURE__*/React.createElement(Base, _extends({
      textColor: color
    }, rest, ariaObject, {
      Component: "svg",
      className: classes,
      dangerouslySetInnerHTML: {
        __html: bodyFinal
      },
      style: { ...sizeStyle,
        ...style
      },
      viewBox: viewBox
    }));
  }

}

_defineProperty(Icon, "defaultProps", {
  size: "1rem"
});